const evTou5 = (territory) => {
  return {
    name: 'TOU-D-5to8',
    title: 'TOU-D-5to8',
    rateElements: [
      {
        name: 'Energy Charges',
        rateElementType: 'EnergyTimeOfUse',
        rateComponents: [
          {
            charge: 0.47973,
            months: [0, 1, 2, 3, 4, 10, 11],
            hourStarts: [16, 17, 18, 19, 20],
            daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
            name: 'Winter On Peak',
          },
          {
            charge: 0.43094,
            months: [0, 1, 4, 10, 11],
            hourStarts: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 21, 22, 23],
            daysOfWeek: [1, 2, 3, 4, 5],
            name: 'Winter Off Peak Weekdays',
          },
          {
            charge: 0.43094,
            months: [2, 3],
            hourStarts: [6, 7, 8, 9, 14, 15, 21, 22, 23],
            daysOfWeek: [1, 2, 3, 4, 5],
            name: 'Winter Off Peak Weekdays Part 2',
          },
          {
            charge: 0.43094,
            months: [0, 1, 2, 3, 4, 10, 11],
            hourStarts: [14, 15, 21, 22, 23],
            daysOfWeek: [0, 6],
            name: 'Winter Off Peak Weekend',
          },
          {
            charge: 0.09852,
            months: [0, 1, 4, 10, 11],
            hourStarts: [0, 1, 2, 3, 4, 5],
            daysOfWeek: [1, 2, 3, 4, 5],
            name: 'Winter Super Off Peak Weekdays',
          },
          {
            charge: 0.09852,
            months: [2, 3],
            hourStarts: [0, 1, 2, 3, 4, 5, 10, 11, 12, 13],
            daysOfWeek: [1, 2, 3, 4, 5],
            name: 'Winter Super Off Peak Weekdays Part 2',
          },
          {
            charge: 0.09852,
            months: [0, 1, 2, 3, 4, 10, 11],
            hourStarts: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
            daysOfWeek: [0, 6],
            name: 'Winter Super Off Peak Weekend',
          },
          {
            charge: 0.71307,
            months: [5, 6, 7, 8, 9],
            hourStarts: [16, 17, 18, 19, 20],
            daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
            name: 'Summer On Peak',
          },
          {
            charge: 0.45661,
            months: [5, 6, 7, 8, 9],
            hourStarts: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 21, 22, 23],
            daysOfWeek: [1, 2, 3, 4, 5],
            name: 'Summer Off Peak Weekdays',
          },
          {
            charge: 0.45661,
            months: [5, 6, 7, 8, 9],
            hourStarts: [14, 15, 21, 22, 23],
            daysOfWeek: [0, 6],
            name: 'Summer Off Peak Weekend',
          },
          {
            charge: 0.10488,
            months: [5, 6, 7, 8, 9],
            hourStarts: [0, 1, 2, 3, 4, 5],
            daysOfWeek: [1, 2, 3, 4, 5],
            name: 'Summer Super Off Peak Weekdays',
          },
          {
            charge: 0.10488,
            months: [5, 6, 7, 8, 9],
            hourStarts: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
            daysOfWeek: [0, 6],
            name: 'Summer Super Off Peak Weekend',
          },
        ],
      },
      {
        name: 'Fixed Monthly Charge',
        rateElementType: 'FixedPerMonth',
        rateComponents: [
          {
            charge: 24.15,
            name: 'Fixed Tax',
          },
        ],
      },
    ],
  };
};

export default evTou5;
